import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Card from '@material-ui/core/Card';
import Divider from '@material-ui/core/Divider';
import IndentedCardHeader from '../../../components/IndentedCardHeader/IndentedCardHeader.js';
import IndentedCardContent from '../../../components/IndentedCardContent/IndentedCardContent.js';

import styles from './styles.js';

function AccountTransactionsCard(props) {
  const { classes, icon, title, body } = props;

  return (
    <div>
      <Card className='Card'>
        <IndentedCardHeader
          title={<Typography variant='h3'>{title}</Typography>}
          avatar={icon}
        />
        <div className={classes.negativeTopMargin}>
          <IndentedCardContent
            body={
              <React.Fragment>
                <Divider />
                <div className={classes.body}>{body}</div>
              </React.Fragment>
            }
          />
        </div>
      </Card>
    </div>
  );
}

AccountTransactionsCard.propTypes = {
  classes: PropTypes.object.isRequired,
  icon: PropTypes.object.isRequired,
  title: PropTypes.string.isRequired,
  body: PropTypes.object.isRequired,
  helpText: PropTypes.string,
};

AccountTransactionsCard.defaultProps = {
  helpText: null,
};

export default withStyles(styles)(AccountTransactionsCard);
